import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const HomePage = () => {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    document.title = 'Pintor Barcelona | PINTORDECO | Pintores Profesionales en Barcelona';
    
    // Update canonical URL
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', `${siteUrl}/`);
    }
    
    // Update Open Graph meta tags
    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', `${siteUrl}/`);
    }
    
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'Pintor Barcelona | PINTORDECO | Pintores Profesionales en Barcelona');
    }
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Pintor profesional en Barcelona. Pintura interior, exterior, locales y oficinas. Presupuesto gratis. Calidad, limpieza y puntualidad. ☎️ 690 22 09 44');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Pintor profesional en Barcelona. Pintura interior, exterior, locales y oficinas. Presupuesto gratis. Calidad, limpieza y puntualidad. ☎️ 690 22 09 44';
      document.head.appendChild(meta);
    }
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', 'Pintor profesional en Barcelona. Pintura interior, exterior, locales y oficinas. Presupuesto gratis. Calidad, limpieza y puntualidad.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'pintor Barcelona, pintores en Barcelona, pintar piso Barcelona, pintura interior Barcelona, presupuesto pintor Barcelona');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'keywords';
      meta.content = 'pintor Barcelona, pintores en Barcelona, pintar piso Barcelona, pintura interior Barcelona, presupuesto pintor Barcelona';
      document.head.appendChild(meta);
    }

    // Structured Data - LocalBusiness & WebPage
    const scriptLD = document.createElement('script');
    scriptLD.type = 'application/ld+json';
    scriptLD.text = JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "ProfessionalService",
          "@id": `${siteUrl}/#organization`,
          "name": "PINTORDECO Barcelona",
          "url": siteUrl,
          "logo": `${siteUrl}/vite.svg`,
          "image": `${siteUrl}/vite.svg`,
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Carrer de Sant Eloi, 2, B",
            "addressLocality": "Barcelona",
            "addressRegion": "Barcelona",
            "postalCode": "08038",
            "addressCountry": "ES"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "41.3759799",
            "longitude": "2.1493607"
          },
          "telephone": "+34690220944",
          "priceRange": "€€",
          "areaServed": [
            {
              "@type": "City",
              "name": "Barcelona"
            },
            {
              "@type": "City",
              "name": "L'Hospitalet de Llobregat"
            },
            {
              "@type": "City",
              "name": "Badalona"
            }
          ],
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "08:00",
              "closes": "20:00"
            },
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": "Saturday",
              "opens": "09:00",
              "closes": "14:00"
            }
          ]
        },
        {
          "@type": "WebPage",
          "@id": `${siteUrl}/#webpage`,
          "url": `${siteUrl}/`,
          "name": "Pintor Barcelona | PINTORDECO | Pintores Profesionales en Barcelona",
          "description": "Pintor profesional en Barcelona. Pintura interior, exterior, locales y oficinas. Presupuesto gratis. Calidad, limpieza y puntualidad.",
          "inLanguage": "es-ES",
          "isPartOf": {
            "@type": "WebSite",
            "@id": `${siteUrl}/#website`,
            "url": siteUrl,
            "name": "PINTORDECO Barcelona"
          },
          "about": {
            "@id": `${siteUrl}/#organization`
          }
        }
      ]
    });
    document.head.appendChild(scriptLD);
    
    return () => {
      if (scriptLD.parentNode) {
        scriptLD.parentNode.removeChild(scriptLD);
      }
    };
  }, []);

  const servicios = [
    {
      title: 'Pintura Interior',
      image: 'https://public.readdy.ai/ai/img_res/9d56d0d6a0f4148bacb7880198b3498a.jpg',
    },
    {
      title: 'Alisar Gotelé',
      image: 'https://readdy.ai/api/search-image?query=painter%20smoothing%20ceiling%20texture%20removal%20white%20walls%20modern%20apartment&width=300&height=200&seq=service-gotele-1&orientation=landscape',
    },
    {
      title: 'Locales Comerciales',
      image: 'https://readdy.ai/api/search-image?query=commercial%20space%20painting%20modern%20store%20white%20walls%20professional%20work&width=300&height=200&seq=service-local-1&orientation=landscape',
    },
  ];

  const proceso = [
    {
      numero: '01',
      titulo: 'Valoración',
      descripcion: 'Valoramos tu proyecto con fotos o visita para entender tus necesidades',
      icon: 'ri-camera-line',
    },
    {
      numero: '02',
      titulo: 'Presupuesto',
      descripcion: 'Te enviamos un presupuesto detallado por escrito sin compromiso',
      icon: 'ri-file-text-line',
    },
    {
      numero: '03',
      titulo: 'Ejecución',
      descripcion: 'Preparamos, protegemos y pintamos con materiales de calidad',
      icon: 'ri-paint-brush-line',
    },
    {
      numero: '04',
      titulo: 'Entrega',
      descripcion: 'Limpieza final, revisión y entrega de tu espacio renovado',
      icon: 'ri-checkbox-circle-line',
    },
  ];

  const zonas = [
    { nombre: 'Sants-Montjuïc', tipo: 'distrito', descripcion: 'Sants, Hostafrancs, Poble Sec, La Marina' },
    { nombre: 'Eixample', tipo: 'distrito', descripcion: 'Dreta, Esquerra, Fort Pienc, Sagrada Família' },
    { nombre: 'Gràcia', tipo: 'distrito', descripcion: 'Vila de Gràcia, Vallcarca, Penitents' },
    { nombre: 'Sarrià-Sant Gervasi', tipo: 'distrito', descripcion: 'Sarrià, Les Tres Torres, Sant Gervasi' },
    { nombre: 'Ciutat Vella', tipo: 'distrito', descripcion: 'Raval, Gótico, Barceloneta, Sant Pere' },
    { nombre: 'Les Corts', tipo: 'distrito', descripcion: 'Les Corts, Pedralbes, La Maternitat' },
    { nombre: 'Horta-Guinardó', tipo: 'distrito', descripcion: 'Horta, Guinardó, Vall d\'Hebron' },
    { nombre: 'Nou Barris', tipo: 'distrito', descripcion: 'Torre Baró, Trinitat Nova, Roquetes' },
    { nombre: 'Sant Andreu', tipo: 'distrito', descripcion: 'Sant Andreu, Sagrera, Trinitat Vella' },
    { nombre: 'Sant Martí', tipo: 'distrito', descripcion: 'Poblenou, Vila Olímpica, Diagonal Mar' },
    { nombre: 'L\'Hospitalet de Llobregat', tipo: 'municipio', descripcion: 'Collblanc, Torrassa, Bellvitge' },
    { nombre: 'Badalona', tipo: 'municipio', descripcion: 'Centro, Gorg, Llefià, Progrés' },
    { nombre: 'Santa Coloma de Gramenet', tipo: 'municipio', descripcion: 'Santa Rosa, Fondo, Singuerlin' },
    { nombre: 'Sant Adrià de Besòs', tipo: 'municipio', descripcion: 'La Mina, Camp de la Bota, Sant Adrià' },
    { nombre: 'Esplugues de Llobregat', tipo: 'municipio', descripcion: 'Centro, Can Vidalet, La Plana' },
    { nombre: 'Cornellà de Llobregat', tipo: 'municipio', descripcion: 'Almeda, Sant Ildefons, Centro' },
    { nombre: 'El Prat de Llobregat', tipo: 'municipio', descripcion: 'Centro, Sant Cosme, Ribera' },
    { nombre: 'Sant Boi de Llobregat', tipo: 'municipio', descripcion: 'Vinyets, Marianao, Molí Nou' },
    { nombre: 'Castelldefels', tipo: 'municipio', descripcion: 'Playa, Poblenou, Can Bou' },
    { nombre: 'Gavà', tipo: 'municipio', descripcion: 'Gavà Mar, Centro, Bruguers' },
    { nombre: 'Viladecans', tipo: 'municipio', descripcion: 'Centro, Eixample, Muntanyeta' },
    { nombre: 'Sant Just Desvern', tipo: 'municipio', descripcion: 'Centro, Can Güell, Can Paulet' },
  ];

  const testimonios = [
    {
      nombre: 'María González',
      ubicacion: 'Sants, Barcelona',
      texto: 'Excelente trabajo pintando mi piso. Muy limpios y profesionales. El resultado superó mis expectativas. Totalmente recomendable.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20spanish%20woman%20smiling%20business%20casual%20neutral%20simple%20background%20headshot%20friendly%20modern%20clean%20professional%20photography&width=100&height=100&seq=testimonial-maria-1&orientation=squarish',
    },
    {
      nombre: 'Carlos Martín',
      ubicacion: 'Eixample, Barcelona',
      texto: 'Profesionales de confianza. Alisaron el gotelé de todo el piso y quedó perfecto. Precio justo y entrega puntual.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20spanish%20man%20smiling%20business%20casual%20neutral%20simple%20background%20headshot%20friendly%20modern%20clean%20professional%20photography&width=100&height=100&seq=testimonial-carlos-1&orientation=squarish',
    },
    {
      nombre: 'Laura Vidal',
      ubicacion: 'Gràcia, Barcelona',
      texto: 'Pintaron mi local comercial en tiempo récord. Muy atentos a los detalles y respetaron los horarios acordados.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20spanish%20woman%20smiling%20business%20casual%20neutral%20simple%20background%20headshot%20friendly%20modern%20clean%20professional%20photography&width=100&height=100&seq=testimonial-laura-1&orientation=squarish',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center pt-32 pb-20">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://readdy.ai/api/search-image?query=bright%20minimalist%20white%20living%20room%20large%20windows%20natural%20sunlight%20modern%20interior&width=1920&height=1080&seq=hero-bg-1&orientation=landscape)',
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="grid lg:grid-cols-12 gap-8 items-center">
            {/* Contenido Izquierdo */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              className="lg:col-span-5"
            >
              <h1 className="text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
                Pintor profesional en Barcelona
              </h1>
              <p className="text-xl text-white/90 mb-6">
                Calidad, limpieza y puntualidad en cada proyecto de pintura
              </p>
              <p className="text-lg text-white/80 mb-8">
                <a 
                  href="https://pintordeco.com/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-accent transition-colors underline"
                >
                  Especialistas en pintura interior y exterior
                </a> de pisos, casas, locales y oficinas en Barcelona. Más de 15 años transformando espacios con profesionalidad. <Link to="/empresa" className="text-white hover:text-accent transition-colors underline">Conoce nuestro equipo</Link>.
              </p>

              <div className="space-y-3">
                <a
                  href="tel:+34690220944"
                  className="whitespace-nowrap w-full sm:w-auto flex items-center justify-center space-x-3 px-8 py-4 bg-accent text-white rounded-full font-semibold text-lg hover:bg-accent/90 transition-all cursor-pointer shadow-lg"
                >
                  <i className="ri-phone-line text-xl"></i>
                  <span>Llamar ahora: 690 22 09 44</span>
                </a>
                <a
                  href="https://wa.me/34690220944"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whitespace-nowrap w-full sm:w-auto flex items-center justify-center space-x-3 px-8 py-4 bg-accent text-white rounded-full font-semibold text-lg hover:bg-accent/90 transition-all cursor-pointer shadow-lg"
                >
                  <i className="ri-whatsapp-line text-xl"></i>
                  <span>WhatsApp</span>
                </a>
                <Link
                  to="/contacto"
                  className="whitespace-nowrap w-full sm:w-auto flex items-center justify-center space-x-3 px-8 py-4 bg-white/10 backdrop-blur-sm text-white border-2 border-white rounded-full font-semibold text-lg hover:bg-white/20 transition-all cursor-pointer"
                >
                  <i className="ri-file-list-line text-xl"></i>
                  <span>Pedir presupuesto gratis</span>
                </Link>
              </div>
            </motion.div>

            {/* Imagen Central */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="lg:col-span-4 hidden lg:block"
            >
              <div className="relative">
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20painter%20working%20interior%20wall%20white%20paint%20roller%20barcelona%20uniform&width=500&height=700&seq=hero-painter-1&orientation=portrait"
                  alt="Pintor profesional trabajando en Barcelona"
                  className="w-full h-auto rounded-3xl shadow-2xl object-cover"
                  loading="eager"
                  fetchpriority="high"
                />
              </div>
            </motion.div>

            {/* Servicios Destacados */}
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="lg:col-span-3 space-y-4"
            >
              <div className="flex items-center space-x-2 text-white mb-4">
                <span className="text-sm font-semibold uppercase tracking-wide">Servicios destacados</span>
                <i className="ri-arrow-right-up-line"></i>
              </div>

              {servicios.map((servicio, index) => (
                <div
                  key={index}
                  className="relative rounded-2xl overflow-hidden group cursor-pointer shadow-lg"
                >
                  <div className="w-full h-32 overflow-hidden">
                    <img
                      src={servicio.image}
                      alt={servicio.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      loading={index === 0 ? "eager" : "lazy"}
                    />
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4">
                    <h3 className="text-white font-semibold text-sm">{servicio.title}</h3>
                  </div>
                </div>
              ))}
            </motion.div>
          </div>
        </div>
      </section>

      {/* Sección de Proceso */}
      <section className="py-20 bg-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl lg:text-5xl font-bold text-primary mb-4">
              Nuestro proceso de trabajo
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Un método profesional que garantiza{' '}
              <a 
                href="https://pintor-barcelona.com.es/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-accent transition-colors underline"
              >
                resultados excepcionales en cada proyecto de pintura
              </a> en Barcelona. <Link to="/faq" className="text-gray-600 hover:text-accent transition-colors underline">Consulta las preguntas frecuentes</Link> sobre nuestro proceso.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {proceso.map((paso, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="relative"
              >
                <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow">
                  <div className="w-20 h-20 bg-primary rounded-full flex items-center justify-center mb-4 mx-auto">
                    <i className={`${paso.icon} text-3xl text-white`}></i>
                  </div>
                  <div className="text-center">
                    <div className="text-4xl font-bold text-accent mb-2">{paso.numero}</div>
                    <h3 className="text-xl font-bold text-primary mb-2">{paso.titulo}</h3>
                    <p className="text-gray-600">{paso.descripcion}</p>
                  </div>
                </div>
                {index < proceso.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-4 w-8 h-0.5 bg-primary/20 border-t-2 border-dashed border-primary/30"></div>
                )}
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Grid de Servicios */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl lg:text-5xl font-bold text-dark mb-4">
              Servicios de <span className="text-accent">pintura en Barcelona</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Ofrecemos soluciones completas de <Link to="/servicios" className="text-gray-600 hover:text-accent transition-colors font-semibold underline">pintura profesional</Link> para todo tipo de espacios en Barcelona y alrededores
            </p>
          </motion.div>

          <div className="grid lg:grid-cols-2 gap-6">
            {/* Tarjeta Grande */}
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              className="relative lg:row-span-2 rounded-3xl overflow-hidden group cursor-pointer shadow-xl h-full min-h-[500px]"
            >
              <div className="w-full h-full">
                <img
                  src="https://readdy.ai/api/search-image?query=apartment%20interior%20painting%20finished%20white%20walls%20modern%20living%20room%20bright%20natural%20light&width=700&height=900&seq=service-full-apartment-1&orientation=portrait"
                  alt="Pintura de pisos completos en Barcelona"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                <h3 className="text-3xl font-bold mb-3">Pintura de pisos completos</h3>
                <p className="text-white/90 mb-4">
                  Renovamos tu piso de principio a fin. Preparación, protección, pintura de paredes y techos, y limpieza final incluida. <Link to="/servicios" className="text-white hover:text-accent transition-colors underline">Ver detalles del servicio</Link>.
                </p>
                <Link
                  to="/servicios"
                  className="whitespace-nowrap inline-flex items-center space-x-2 text-accent font-semibold hover:translate-x-2 transition-transform cursor-pointer"
                >
                  <span>Ver más</span>
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </motion.div>

            {/* Tarjetas Pequeñas */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
              className="relative rounded-3xl overflow-hidden group cursor-pointer shadow-xl h-60"
            >
              <div className="w-full h-full bg-accent/10">
                <img
                  src="https://readdy.ai/api/search-image?query=commercial%20retail%20store%20interior%20white%20walls%20modern%20shop%20bright%20lighting&width=700&height=400&seq=service-commercial-1&orientation=landscape"
                  alt="Pintura de locales comerciales Barcelona"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                <h3 className="text-2xl font-bold mb-2">Locales comerciales</h3>
                <p className="text-white/90 text-sm mb-3">
                  Pintura profesional para tiendas, oficinas y espacios comerciales. Coordinamos horarios según tu actividad. <Link to="/empresa" className="text-white hover:text-accent transition-colors underline">Conoce cómo trabajamos</Link>.
                </p>
                <Link
                  to="/servicios"
                  className="whitespace-nowrap inline-flex items-center space-x-2 text-accent font-semibold cursor-pointer"
                >
                  <span>Más info</span>
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="relative rounded-3xl overflow-hidden group cursor-pointer shadow-xl h-60"
            >
              <div className="w-full h-full bg-pink-100/30">
                <img
                  src="https://readdy.ai/api/search-image?query=smooth%20ceiling%20finish%20texture%20removal%20white%20walls%20modern%20apartment%20interior&width=700&height=400&seq=service-ceiling-texture-1&orientation=landscape"
                  alt="Alisado de gotelé Barcelona"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                <h3 className="text-2xl font-bold mb-2">Alisado de gotelé</h3>
                <p className="text-white/90 text-sm mb-3">
                  Eliminamos el gotelé y dejamos paredes y techos completamente lisos. Acabado perfecto garantizado.
                </p>
                <Link
                  to="/servicios"
                  className="whitespace-nowrap inline-flex items-center space-x-2 text-accent font-semibold cursor-pointer"
                >
                  <span>Más info</span>
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </motion.div>
          </div>

          <div className="mt-12 text-center">
            <Link
              to="/servicios"
              className="whitespace-nowrap inline-flex items-center space-x-2 px-8 py-4 bg-primary text-white rounded-full font-semibold text-lg hover:bg-primary/90 transition-all cursor-pointer shadow-lg"
            >
              <span>Ver todos los servicios</span>
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Sección de Zonas */}
      <section className="py-20 bg-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <span className="inline-block px-4 py-2 bg-accent/10 text-accent font-semibold rounded-full text-sm mb-4">
              COBERTURA COMPLETA
            </span>
            <h2 className="text-4xl lg:text-5xl font-bold text-primary mb-4">
              Pintores en Barcelona y área metropolitana
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Ofrecemos servicios profesionales de pintura en todos los distritos de Barcelona y municipios del área metropolitana. <Link to="/contacto" className="text-gray-600 hover:text-accent transition-colors underline">Consulta disponibilidad en tu zona</Link>.
            </p>
          </motion.div>

          {/* Distritos de Barcelona */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mb-12"
          >
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-primary rounded-xl flex items-center justify-center mr-4">
                <i className="ri-map-pin-2-fill text-accent text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-primary">Distritos de Barcelona</h3>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              {zonas.filter(z => z.tipo === 'distrito').map((zona, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.05 }}
                  className="bg-white rounded-xl p-5 shadow-md hover:shadow-xl transition-all cursor-pointer hover:-translate-y-1 group border border-gray-100"
                >
                  <div className="flex items-start justify-between mb-3">
                    <div className="w-10 h-10 bg-gradient-to-br from-accent/20 to-accent/5 rounded-lg flex items-center justify-center group-hover:from-accent group-hover:to-accent/80 transition-all">
                      <i className="ri-building-4-line text-accent group-hover:text-white transition-colors text-xl"></i>
                    </div>
                    <i className="ri-arrow-right-up-line text-gray-300 group-hover:text-accent transition-colors"></i>
                  </div>
                  <h4 className="font-bold text-primary mb-2 text-lg group-hover:text-accent transition-colors">
                    {zona.nombre}
                  </h4>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {zona.descripcion}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Municipios cercanos */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-primary rounded-xl flex items-center justify-center mr-4">
                <i className="ri-community-line text-accent text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-primary">Municipios del área metropolitana</h3>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              {zonas.filter(z => z.tipo === 'municipio').map((zona, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.05 }}
                  className="bg-white rounded-xl p-5 shadow-md hover:shadow-xl transition-all cursor-pointer hover:-translate-y-1 group border border-gray-100"
                >
                  <div className="flex items-start justify-between mb-3">
                    <div className="w-10 h-10 bg-gradient-to-br from-primary/20 to-primary/5 rounded-lg flex items-center justify-center group-hover:from-primary group-hover:to-primary/80 transition-all">
                      <i className="ri-map-pin-line text-primary group-hover:text-white transition-colors text-xl"></i>
                    </div>
                    <i className="ri-arrow-right-up-line text-gray-300 group-hover:text-primary transition-colors"></i>
                  </div>
                  <h4 className="font-bold text-primary mb-2 text-lg group-hover:text-accent transition-colors">
                    {zona.nombre}
                  </h4>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {zona.descripcion}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Información adicional */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mt-12 bg-gradient-to-br from-primary to-primary/90 rounded-3xl p-8 shadow-xl text-white"
          >
            <div className="grid lg:grid-cols-2 gap-8 items-center">
              <div>
                <div className="flex items-center mb-4">
                  <i className="ri-map-2-line text-accent text-3xl mr-3"></i>
                  <h3 className="text-2xl font-bold">¿Tu zona no aparece en la lista?</h3>
                </div>
                <p className="text-white/90 mb-4 leading-relaxed">
                  También trabajamos en otras localidades cercanas del área metropolitana de Barcelona. Contáctanos para consultar disponibilidad y presupuesto en tu ubicación.
                </p>
                <p className="text-sm text-white/80 italic">
                  Nos desplazamos a municipios cercanos sin coste adicional según la zona y el proyecto.
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-3">
                <a
                  href="tel:+34690220944"
                  className="whitespace-nowrap flex-1 flex items-center justify-center space-x-2 px-6 py-4 bg-accent text-white rounded-full font-semibold hover:bg-accent/90 transition-all cursor-pointer shadow-lg"
                >
                  <i className="ri-phone-line text-xl"></i>
                  <span>Llamar ahora</span>
                </a>
                <a
                  href="https://wa.me/34690220944"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whitespace-nowrap flex-1 flex items-center justify-center space-x-2 px-6 py-4 bg-white text-primary rounded-full font-semibold hover:bg-white/90 transition-all cursor-pointer shadow-lg"
                >
                  <i className="ri-whatsapp-line text-xl"></i>
                  <span>WhatsApp</span>
                </a>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Testimonios */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <div className="flex items-center justify-center space-x-2 mb-4">
              <i className="ri-star-fill text-accent text-2xl"></i>
              <i className="ri-star-fill text-accent text-2xl"></i>
              <i className="ri-star-fill text-accent text-2xl"></i>
              <i className="ri-star-fill text-accent text-2xl"></i>
              <i className="ri-star-fill text-accent text-2xl"></i>
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-primary mb-4">
              Lo que dicen nuestros clientes
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              La satisfacción de nuestros clientes es nuestra mejor carta de presentación. Lee las opiniones de quienes ya confiaron en nosotros para <Link to="/servicios" className="text-gray-600 hover:text-accent transition-colors underline">pintar en Barcelona</Link>.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-8">
            {testimonios.map((testimonio, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-light rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow"
              >
                <div className="flex items-start space-x-4 mb-4">
                  <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                    <img
                      src={testimonio.avatar}
                      alt={testimonio.nombre}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <h4 className="font-bold text-primary">{testimonio.nombre}</h4>
                    <p className="text-sm text-gray-500">{testimonio.ubicacion}</p>
                  </div>
                </div>
                <div className="flex mb-3">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-accent"></i>
                  ))}
                </div>
                <p className="text-gray-700 italic">&ldquo;{testimonio.texto}&rdquo;</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-20 bg-primary">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <div className="mb-8">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20painting%20team%20working%20interior%20renovation%20barcelona%20painters%20uniform&width=1200&height=400&seq=cta-team-1&orientation=landscape"
                alt="Equipo de pintores profesionales PINTORDECO"
                className="w-full h-64 object-cover rounded-3xl shadow-2xl"
              />
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
              ¿Necesitas un <span className="italic text-accent">pintor profesional</span> en Barcelona?
            </h2>
            <p className="text-xl text-white/90 mb-8 max-w-3xl mx-auto">
              Solicita tu presupuesto gratuito sin compromiso. Te respondemos en menos de 24 horas con un presupuesto detallado y personalizado.
            </p>
            <Link
              to="/contacto"
              className="whitespace-nowrap inline-flex items-center space-x-3 px-10 py-5 bg-accent text-white rounded-full font-bold text-xl hover:bg-accent/90 transition-all cursor-pointer shadow-2xl hover:scale-105"
            >
              <i className="ri-file-list-3-line text-2xl"></i>
              <span>Solicitar presupuesto gratuito</span>
            </Link>
          </motion.div>
        </div>
      </section>

      <Footer />

      {/* Mobile Sticky CTA */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white shadow-2xl border-t border-gray-200 p-4">
        <div className="flex space-x-3">
          <a
            href="tel:+34690220944"
            className="whitespace-nowrap flex-1 flex items-center justify-center space-x-2 px-4 py-3 bg-primary text-white rounded-full font-semibold cursor-pointer"
          >
            <i className="ri-phone-line"></i>
            <span>Llamar</span>
          </a>
          <a
            href="https://wa.me/34690220944"
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap flex-1 flex items-center justify-center space-x-2 px-4 py-3 bg-accent text-white rounded-full font-semibold cursor-pointer"
          >
            <i className="ri-whatsapp-line"></i>
            <span>WhatsApp</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
